// extracted by mini-css-extract-plugin
export default {"container":"ProfileSettings_container__a4ZPz","dropdown":"ProfileSettings_dropdown__D-BO6"};